'use strict';

export const ASSET_ITEM_NAME = 'assetTask';
export const ASSET_ITEM_PREFIX = `@@${ASSET_ITEM_NAME}`;

export const PROJECT_ITEM_NAME = 'projectTask';
export const PROJECT_ITEM_PREFIX = `@@${PROJECT_ITEM_NAME}`;

export const TEMPLATE_ITEM_NAME = 'templateTask';
export const TEMPLATE_ITEM_PREFIX = `@@${TEMPLATE_ITEM_NAME}`;

export const ASSET_LIST_NAME = 'assetTasks';
export const ASSET_LIST_PREFIX = `@@${ASSET_LIST_NAME}`;

export const PROJECT_LIST_NAME = 'projectTasks';
export const PROJECT_LIST_PREFIX = `@@${PROJECT_LIST_NAME}`;

export const TEMPLATE_LIST_NAME = 'templateTasks';
export const TEMPLATE_LIST_PREFIX = `@@${TEMPLATE_LIST_NAME}`;

export const CREATE_ASSET_TASK_NAME = 'createAssetTask';
export const CREATE_ASSET_TASK_PREFIX = `@@${CREATE_ASSET_TASK_NAME}`;

export const CREATE_PROJECT_TASK_NAME = 'createProjectTask';
export const CREATE_PROJECT_TASK_PREFIX = `@@${CREATE_PROJECT_TASK_NAME}`;

export const CREATE_TEMPLATE_TASK_NAME = 'createTemplateTask';
export const CREATE_TEMPLATE_TASK_PREFIX = `@@${CREATE_TEMPLATE_TASK_NAME}`;

export const UPDATE_ASSET_TASK_NAME = 'updateAssetTask';
export const UPDATE_ASSET_TASK_PREFIX = `@@${UPDATE_ASSET_TASK_NAME}`;

export const UPDATE_PROJECT_TASK_NAME = 'updateProjectTask';
export const UPDATE_PROJECT_TASK_PREFIX = `@@${UPDATE_PROJECT_TASK_NAME}`;

export const UPDATE_TEMPLATE_TASK_NAME = 'updateTemplateTask';
export const UPDATE_TEMPLATE_TASK_PREFIX = `@@${UPDATE_TEMPLATE_TASK_NAME}`;



// WEBPACK FOOTER //
// ./src/js/tasks/redux/state.js